var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 53,
    viewBox: "0 0 49 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4021 0.437912H28.2511C23.414 0.437912 18.0337 2.51214 18.0337 9.66094C18.0574 12.1519 18.0337 14.5374 18.0337 17.2222H12.4379V26.3012H18.2069V52.4379H28.8078V26.1287H35.8048L36.4379 17.1967H28.6252C28.6252 17.1967 28.6426 13.2234 28.6252 12.0696C28.6252 9.24451 31.5083 9.40629 31.6817 9.40629C33.0537 9.40629 35.7213 9.41037 36.4061 9.40629V0.437912H36.4021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5f07cd9936143b6c39037c8f262616c4.svg";
export { ForwardRef as ReactComponent };